import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-opt-usuarios',
  templateUrl: './opt-usuarios.component.html',
  styleUrls: ['./opt-usuarios.component.scss'],
})
export class OptUsuariosComponent {
  @Input() agente: any;

  constructor(private popoverController: PopoverController) { }

  seleccionarOpcion(accion: string) {
    this.popoverController.dismiss({ accion, agente: this.agente });
  }
}
